/**
 * @file コンポーネント：フル動画ページノートポップアップ スタイル管理
 */

// ライブラリ読み込み
import styled from "styled-components";

export const StyledPopup = styled.div`
    display: flex;
    flex-direction: column;
    position: relative;
`;
